import validationMessages from 'vee-validate/dist/locale/nl';
//citrix.nl

const yesNoOptions = [
    {value: "Yes", text: "Ja"},
    {value: "No", text: "Nee"}
]

export default {
    privacyLinkLabel: "Privacybeleid",
    privacyLink: '/nl-nl/about/legal/privacy/',
    privacyText: "Citrix verwerkt uw gegevens zoals beschreven in ons",
    resetText: "Als dit formulier al is ingevuld en dit zijn niet uw gegevens,",
    resetText2: "om het formulier leeg te maken.",
    resetLinkText: "klik dan hier",
    yes: "Ja",
    no: "Nee",
    submitBtn: {
        "Submit" : "Verzenden",
        "Get the eBook" : "Download het e-book",
        "Watch demo" : "Watch demo",
        "Get the kit" : "Download de kit",
        "Compare now" : "Vergelijk nu",
        "Request a demo": "Vraag een demo aan",
        "Request a call": "Vraag een gesprek aan"
    },
    apjPrivacy:{
        title: "Hoe wij uw persoonsgegevens gebruiken",
        company: "Citrix Systems Japan K.K.",
        part1: "(\"Citrix\") gebruikt en bewaart uw persoonsgegevens overeenkomstig de van toepassing zijnde wet- en regelgeving inzake gegevensbescherming, het",
        linkText: "Citrix privacybeleid",
        part2: "en wanneer toegang aan strenge restricties gebonden is. Citrix gebruikt uw persoonsgegevens alleen zoals beschreven in het privacybeleid en niet voor andere doeleinden. Overeenkomstig het privacybeleid heeft Citrix het recht de verwerking van persoonsgegevens toe te vertrouwen aan binnen- of buitenlandse bedrijfsonderdelen, om persoonsgegevens te delen met andere Citrix vestigingen of dochterondernemingen wereldwijd, en om persoonsgegevens te verzenden naar derden in binnen- of buitenland. Wanneer u persoonsgegevens bezorgt aan Citrix, stemt u in met de vergaring en verwerking van uw persoonsgegevens zoals beschreven in het Citrix privacybeleid.",
        privacyAccept: "Ik heb het bovenstaande en het Citrix privacybeleid gelezen en ga ermee akkoord"
    },
    fields: {
        "AnnualSales": {
            label: "Annual Sales"
        },
        "Company_Self_Reported__c": {
            label: "Organisatie"
        },
        "department": {
            label: "Afdeling",
            options: [
                { value: "Application Management", text: "Applicatiebeheer" },
                { value: "Consulting Services", text: "Consultingservice" },
                { value: "Education / Training", text: "Educatie / opleiding" },
                { value: "Engineering", text: "Engineering" },
                { value: "Executive Office / Administration", text: "Uitvoerend bureau / beheer" },
                { value: "Finance / Accounting", text: "Financiën / boekhouding" },
                { value: "Human Resources", text: "Human Resources" },
                { value: "Information Technology - Systems", text: "Informatietechnologiesystemen" },
                { value: "Legal", text: "Juridisch" },
                { value: "Marketing / PR", text: "Marketing / PR" },
                { value: "Networking", text: "Networking" },
                { value: "Operations / Manufacturing", text: "Exploitatie / fabricage" },
                { value: "Pre-Sales / Technical Support", text: "Pre-sales- / technische support" },
                { value: "Project Management", text: "Projectbeheer" },
                { value: "Purchasing", text: "Inkoop" },
                { value: "Sales / Bus-Corp Development", text: "Verkoop / handels- en bedrijfsontwikkeling" },
                { value: "Security", text: "Security" },
                { value: "Web / Online / E-Business", text: "Web- / online / e-business" }
            ]
        },
        "Industry_Self_Reported__c": {
            label: "Sector",
            options: [
                { value: "Business Consulting", text: "Bedrijfsconsulting" },
                { value: "Construction and Design", text: "Bouw en ontwerp" },
                { value: "Charitable/Non-Profit", text: "Charitatief/non-profit" },
                { value: "Conglomerate", text: "Conglomeraat" },
                { value: "Retail/Wholesale", text: "Detailhandel/groothandel" },
                { value: "E-Commerce", text: "E-commerce" },
                { value: "Engineering", text: "Engineering" },
                { value: "Entertainment", text: "Entertainment" },
                { value: "Chemical Manufacturing", text: "Fabricage van chemische stoffen" },
                { value: "Pharmaceuticals", text: "Farmaceutische producten" },
                { value: "Finance", text: "Financiële sector" },
                { value: "Health Care", text: "Gezondheidszorg" },
                { value: "Hospitality", text: "Horeca" },
                { value: "Household Services", text: "Huishoudelijke dienstverlening" },
                { value: "Legal", text: "Juridisch" },
                { value: "Art & Membership", text: "Kunst en lidmaatschap" },
                { value: "Agriculture", text: "Landbouw" },
                { value: "Mining - All", text: "Mijnbouw - alle" },
                { value: "Utilities", text: "Nutsvoorzieningen" },
                { value: "Oil and Gas", text: "Olie en gas" },
                { value: "Education", text: "Onderwijs" },
                { value: "Government/Local", text: "Overheid/lokaal" },
                { value: "Government/National-Federal", text: "Overheid/nationaal-federaal" },
                { value: "Government/State-Province", text: "Overheid/staat-provincie" },
                { value: "Personnel Services", text: "Personeelservices" },
                { value: "Manufacturing", text: "Productie" },
                { value: "Professional Services", text: "Professionele services" },
                { value: "Publishing/Printing", text: "Publiceren/drukken" },
                { value: "Service Provider", text: "Service Provider" },
                { value: "Technology", text: "Technologie" },
                { value: "Telecommunication", text: "Telecommunicatie" },
                { value: "Real Estate", text: "Vastgoed" },
                { value: "Consumer Packaged Goods", text: "Verpakte consumentengoederen" },
                { value: "Transportation", text: "Vervoer" },
                { value: "Insurance", text: "Verzekering" },
                { value: "Business/Personal Services", text: "Zakelijke/persoonlijke dienstverlening" }
            ]
        },
        "NumberOfEmployees_Self_Reported__c" : {
            label: "Grootte van de organisatie",
            options: [
                { value: "50", text: "1-50" },
                { value: "500", text: "51-500" },
                { value: "749", text: "501-749" },
                { value: "4999", text: "750-4,999" },
                { value: "19999", text: "5,000-19,999" },
                { value: "20000", text: "20,000+" }
            ]
        },
        "NumberofEmployees__here___atlocation": {
            label: "Grootte van de organisatie",
            opyions: [
                { value: "5,001 +", text: "5.001 +" },
                { value: "1,001 to 5,000", text: "1.001 tot 5.000" },
                { value: "501 to 1,000", text: "501 tot 1.000" },
                { value: "251 to 500", text: "251 tot 500" },
                { value: "1 to 250", text: "1 tot 250" }
            ]
        },
        "Address2": {
            label: "Adresregel 2"
        },
        "Address3": {
            label: "Adresregel 3"
        },
        "city": {
            label: "City"
        },
        "country": {
            label: "Land"
        },
        "email": {
            label: "E-mail werk"
        },
        "firstName": {
            label: "Voornaam"
        },
        "lastName": {
            label: "Achternaam"
        },
        "phone": {
            label: "Telefoonnummer"
        },
        "mobilePhone": {
            label: "Mobile Phone"
        },
        "postalCode": {
            label: "Postcode"
        },
        "salutation": {
            label: "Aanhef",
            options: [
                { value: "", text: ""},
                { value: "Dr.", text: "Dr."},
                { value: "Egr. Sig.", text: "Egr. Sig."},
                { value: "Frau", text: "Frau"},
                { value: "Gent.ma Sig.ra", text: "Gent.ma Sig.ra"},
                { value: "Herr", text: "Herr"},
                { value: "Madame", text: "Madame"},
                { value: "Mademoiselle", text: "Mademoiselle"},
                { value: "Miss", text: "Miss"},
                { value: "Monsieur", text: "Monsieur"},
                { value: "Mr.", text: "Mr."},
                { value: "Mrs.", text: "Mrs."},
                { value: "Ms.", text: "Ms."},
                { value: "Professor", text: "Professor"},
                { value: "Señor", text: "Señor"},
                { value: "Señora", text: "Señora"}
            ]
        },
        "state": {
            label: "Staat/provincie"
        },
        "address": {
            label: "Adres"
        },
        "Job_Title__c": {
            label: "Functietitel"
        },
        "Project_Budget__c": {
            label: "Projectbudget",
            options: [
                { value: "Yes", text: "Ja" },
                { value: "No", text: "Nee" },
                { value: "Unknown", text: "Onbekend" }
            ]
        },
        "Primary_Product_Interest__c": {
            label: "(CTRL om meer dan één keuze te selecteren (max. 5 keuzes)"
        },
        "Purchase_Timeframe__c": {
            label: "Tijdsbestek aankoop",
            options: [
                { value: "3 months or less", text: "3 maanden of minder" },
                { value: "4 to 6 months", text: "4 tot 6 maanden" },
                { value: "7 months or more", text: "7 maanden of meer" },
                { value: "No time frame", text: "Geen tijdskader" },
                { value: "Unknown", text: "Onzeker" }
            ]
        },
        "Email_Blast_OK__c": {
            label: "Mogen wij u e-mail sturen?",
            options: [
                { value: "Yes", text: "Ja" },
                { value: "No", text: "Nee" }
            ]
        },
        "Direct_Mail_OK__c": {
            label: "May we contact you by mail?",
            options: [
                { value: "Yes", text: "Ja" },
                { value: "No", text: "Nee" }
            ]
        },
        "OK_to_Call__c": {
            label: "Mogen wij u bellen?",
            options: [
                { value: "Yes", text: "Ja" },
                { value: "No", text: "Nee" }
            ]
        },
        "Preferred_Language__c": {
            label: "Preffered language"
        },
        "Sales_Contact_Requested__c": {
            label: "Laat een verkoper contact met mij opnemen"
        },
        "Comments_6__c":{
            label: "Opmerkingen"
        },
        //PrefCenter fields/options
        "Unsubscribed": {
            label: "Afmelden voor alle marketingcommunicatie via e-mail.",
            options: [...yesNoOptions]
        },
        "Marketing_Suspended_30_Days__c": {
            label: "Geen berichten gedurende 30 dagen.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_Workspace__c": {
            label: "Hoe complete digitale workspaces, voor al uw apps, desktops, bestanden en mobiele devices, u helpen om beter te presteren, vanaf elke locatie.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_VirtualAppsDesktops__c": {
            label: "Hoe u veilige toegang mogelijk maakt tot alle apps, desktops en data vanaf elk device.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_NetworkingADC__c": {
            label: "Hoe u uw app delivery (voor zowel monolithische apps als apps op basis van microservices) beheert in een hybride, ‘multi-cloud’ wereld.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_SDWan__c": {
            label: "Hoe u een altijd beschikbaar, krachtig netwerk creëert voor uw gebruikers.",
            options: [...yesNoOptions]
        },
        "Preferred_Topic_Analytics__c": {
            label: "Hoe u securityrisico’s en afwijkingen in de performance detecteert met analytics en inzicht om tijdig ingrijpen mogelijk te maken.",
            options: [...yesNoOptions]
        }
    },
    optOut: {
        formTitle: "Afmelden",
        thankyou: "Uw e-mailvoorkeuren zijn bijgewerkt. Als dit per ongeluk is gebeurd of als u uw voorkeuren opnieuw wilt aanpassen, ga dan terug naar de voorkeurenpagina.",
        formDescription: "Jammer dat u vertrekt. Breng regelmatig een bezoek aan Citrix.nl. We voegen constant nieuwe functies en mogelijkheden toe om de producten van Citrix nog beter te maken voor u.",

    },
    preferenceCenter: {
        formTitle: "Citrix e-mailvoorkeuren",
        thankyou: "<h3>Wijzigingen bevestigd!</h3><p>Uw e-mailvoorkeuren zijn bijgewerkt.</p>",
        formDescription: "Uw e-mail- en communicatievoorkeuren zijn belangrijk voor ons. We willen u informatie sturen die voor u en uw organisatie nuttig is.  Pas uw e-mailvoorkeuren aan zodat wij u de informatie kunnen bezorgen waarin u geïnteresseerd bent.",
        labelOne: "Vertel ons wat meer over uzelf",
        labelTwo: "In welke onderwerpen bent u geïnteresseerd?",
        labelThree: "Hoe mogen wij met u communiceren?",
    },
    validation: validationMessages
}